module.exports = __webpack_public_path__ + "img/5.641f2581.png";